/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import {
  Image,
  Button,
  Container,
  Navbar,
  Nav,
  NavDropdown,
} from 'react-bootstrap';
import * as S from './styles';
import { HashLink } from 'react-router-hash-link';
import './styles.css';

export interface INavItemProps {
  name: string;
  link?: string;
}

export interface IHeaderCompProps {
  searchBar: boolean;
  headerLogo?: string;
  headerLink?: string;
  headerTitle?: string;
  headerTitleStyle?: any;
  navItems?: INavItemProps[];
  buttonItem?: {
    name: string;
    link: string;
  };
  activeButton: string;
  setActiveButton: (name: string) => void;
}

export const HeaderComp = ({
  headerLogo,
  headerLink,
  headerTitle,
  headerTitleStyle,
  navItems,
  buttonItem,
  searchBar,
  activeButton,
  setActiveButton,
}: IHeaderCompProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const _renderBrandLogo = () => {
    if (headerLogo) {
      return (
        <Navbar.Brand
          as={HashLink}
          to={headerLink}
          className="me-lg-3 d-flex align-items-center"
        >
          <Image src={headerLogo} height={40} />
          {headerTitle && (
            <span
              className="ms-2 brand-text d-none d-md-inline"
              style={headerTitleStyle}
            >
              {headerTitle}
            </span>
          )}
        </Navbar.Brand>
      );
    }
  };

  const _getNavItem = (item, index) => {
    if (item?.type === 'collapsable') {
      return (
        <NavDropdown title={item?.name} id="nav-dropdown">
          {item?.children?.map((key, i) => {
            return (
              <NavDropdown.Item
                eventKey={`header-nav-dropdown-${i}-${index}`}
                as={HashLink}
                to={key?.link ?? '#'}
                onClick={() => setActiveButton(key?.name)}
              >
                {key?.name}
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>
      );
    } else {
      return (
        <Nav.Link
          key={`header-navbar-link-item-${index}`}
          as={HashLink}
          to={item?.link ?? '#'}
          onClick={() => setActiveButton(item?.name)}
        >
          {item.name}
        </Nav.Link>
      );
    }
  };

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const _renderSearchBar = () => {
    return (
      <S.SearchContainer>
        <S.SearchBar
          placeholder={'Search'}
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
        />
        <S.SubmitButton
          disabled={searchQuery.trim() === ''}
          onClick={() => {
            window.open(
              `https://mlss.gov.jm/?s=${encodeURIComponent(searchQuery)}`,
              '_blank'
            );
          }}
        >
          Search
        </S.SubmitButton>
      </S.SearchContainer>
    );
  };

  const _renderNavItems = () => {
    return (
      <div className="d-flex align-items-center">
        <Navbar.Toggle />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="navbar-nav-hover align-items-lg-center me-auto">
            {navItems?.map((item, index) => _getNavItem(item, index))}
          </Nav>
        </Navbar.Collapse>
        {buttonItem && (
          <Button
            // as={HashLink}
            // to={buttonItem?.link}
            onClick={() => window.open(buttonItem?.link, '_self')}
            variant="outline-secondary"
            className="ms-3"
          >
            {buttonItem?.name}
          </Button>
        )}
      </div>
    );
  };
  return (
    <>
      <Navbar
        collapseOnSelect
        variant="light"
        expand="md"
        bg="light"
        className="navbar-theme-gray sticky-top navbar navbar-theme-white navbar-light bg-light d-xs-none"
      >
        <Container className="position-relative justify-content-between px-3">
          {_renderBrandLogo()}
          {searchBar && _renderSearchBar()}
          {_renderNavItems()}
        </Container>
      </Navbar>
      <div
        style={{ width: '1px', height: '2px', backgroundColor: '#000000' }}
      />
    </>
  );
};

HeaderComp.defaultProps = {
  headerLink: '#home',
};


// import React, { useState } from 'react';
// import {
//   Image,
//   Button,
//   Container,
//   Navbar,
//   Nav,
//   NavDropdown,
// } from 'react-bootstrap';
// import * as S from './styles';
// import { HashLink } from 'react-router-hash-link';
// import './styles.css';

// export interface INavItemProps {
//   name: string;
//   link?: string;
// }

// export interface IHeaderCompProps {
//   searchBar: boolean;
//   headerLogo?: string;
//   headerLink?: string;
//   headerTitle?: string;
//   headerTitleStyle?: any;
//   navItems?: INavItemProps[];
//   buttonItem?: {
//     name: string;
//     link: string;
//   };
//   activeButton: string;
//   setActiveButton: (name: string) => void;
// }

// export const HeaderComp = ({
//   headerLogo,
//   headerLink,
//   headerTitle,
//   headerTitleStyle,
//   navItems,
//   buttonItem,
//   searchBar,
//   activeButton,
//   setActiveButton,
// }: IHeaderCompProps) => {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [isSearchOpen, setIsSearchOpen] = useState(false);

//   const _renderBrandLogo = () => {
//     if (headerLogo) {
//       return (
//         <Navbar.Brand
//           as={HashLink}
//           to={headerLink}
//           className="me-lg-3 d-flex align-items-center"
//         >
//           <Image src={headerLogo} height={40} />
//           {headerTitle && (
//             <span
//               className="ms-2 brand-text d-none d-md-inline"
//               style={headerTitleStyle}
//             >
//               {headerTitle}
//             </span>
//           )}
//         </Navbar.Brand>
//       );
//     }
//   };

//   const _getNavItem = (item, index) => {
//     const isActive = activeButton === item.name;
//     if (item?.type === 'collapsable') {
//       return (
//         <Button
//           key={`header-navbar-link-item-${index}`}
//           variant={isActive ? "secondary" : "outline-secondary"}
//           className="ms-3"
//           onClick={() => setActiveButton(item.name)}
//         >
//           <NavDropdown title={item?.name} id="nav-dropdown">
//             {item?.children?.map((key, i) => {
//               return (
//                 <NavDropdown.Item
//                   eventKey={`header-nav-dropdown-${i}-${index}`}
//                   as={HashLink}
//                   to={key?.link ?? '#'}
//                   onClick={() => setActiveButton(key.name)}
//                 >
//                   {key?.name}
//                 </NavDropdown.Item>
//               );
//             })}
//           </NavDropdown>
//         </Button>
//       );
//     } else {
//       return (
//         <Button
//           key={`header-navbar-link-item-${index}`}
//           as={HashLink}
//           to={item?.link ?? '#'}
//           variant={isActive ? "secondary" : "outline-secondary"}
//           className="ms-3"
//           onClick={() => {
//             setActiveButton(item.name);
//             if (item.name === 'Home') {
//               window.scrollTo(0, 0);
//             }
//           }}
//         >
//           {item.name}
//         </Button>
//       );
//     }
//   };

//   const handleInputChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const _renderSearchBar = () => {
//     return (
//       <S.SearchContainer
//         style={{
//           display: isSearchOpen ? 'flex' : 'none',
//           animation: isSearchOpen ? 'slideIn 0.3s ease-in-out' : 'slideOut 0.3s ease-in-out',
//         }}
//       >
//         <style>
//           {`
//             @keyframes slideIn {
//               from {
//                 transform: translateX(100%);
//                 opacity: 0;
//               }
//               to {
//                 transform: translateX(0);
//                 opacity: 1;
//               }
//             }
//             @keyframes slideOut {
//               from {
//                 transform: translateX(0);
//                 opacity: 1;
//               }
//               to {
//                 transform: translateX(100%);
//                 opacity: 0;
//               }
//             }
//           `}
//         </style>
//         <S.SearchBar
//           placeholder={'Search'}
//           type="text"
//           value={searchQuery}
//           onChange={handleInputChange}
//           style={{ width: '300px' }}
//         />
//         <S.SubmitButton
//           disabled={searchQuery.trim() === ''}
//           onClick={() => {
//             window.open(
//               `https://mlss.gov.jm/?s=${encodeURIComponent(searchQuery)}`,
//               '_blank'
//             );
//           }}
//         >
//           Search
//         </S.SubmitButton>
//       </S.SearchContainer>
//     );
//   };

//   const _renderNavItems = () => {
//     return (
//       <div
//         className="d-flex align-items-center"
//         style={{
//           display: isSearchOpen ? 'none' : 'flex',
//           animation: isSearchOpen ? 'fadeOut 0.3s ease-in-out' : 'fadeIn 0.3s ease-in-out',
//         }}
//       >
//         <style>
//           {`
//             @keyframes fadeIn {
//               from { opacity: 0; }
//               to { opacity: 1; }
//             }
//             @keyframes fadeOut {
//               from { opacity: 1; }
//               to { opacity: 0; }
//             }
//           `}
//         </style>
//         <Navbar.Toggle />
//         <Navbar.Collapse id="responsive-navbar-nav">
//           <Nav className="navbar-nav-hover align-items-lg-center me-auto">
//             {navItems?.map((item, index) => _getNavItem(item, index))}
//           </Nav>
//         </Navbar.Collapse>
//       </div>
//     );
//   };

//   return (
//     <>
//       <Navbar
//         collapseOnSelect
//         variant="light"
//         expand="md"
//         bg="light"
//         className="navbar-theme-gray sticky-top navbar navbar-theme-white navbar-light bg-light d-xs-none"
//       >
//         <Container className="position-relative px-3">
//           {_renderBrandLogo()}
//           {!isSearchOpen && _renderNavItems()}
//           <div className="d-flex align-items-center">
//             {searchBar && _renderSearchBar()}
//             {searchBar && 
//               <Button
//                 variant="light"
//                 className="ms-2"
//                 onClick={() => {
//                   setIsSearchOpen(!isSearchOpen);
//                   setActiveButton('SearchIcon');
//                 }}
//                 style={{ border: 'none', background: 'transparent', marginRight: '8px' }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </Button>
//             }
//             {buttonItem && (
//               <Button
//                 onClick={() => {
//                   setActiveButton(buttonItem.name);
//                   window.open(buttonItem.link, '_self');
//                 }}
//                 variant={activeButton === buttonItem.name ? "secondary" : "outline-secondary"}
//                 className="ms-auto"
//                 style={{ marginLeft: '5px' }}
//               >
//                 {buttonItem.name}
//               </Button>
//             )}
//           </div>
//         </Container>
//       </Navbar>
//       <div
//         style={{ width: '1px', height: '2px', backgroundColor: '#000000' }}
//       />
//     </>
//   );
// };

// HeaderComp.defaultProps = {
//   headerLink: '#home',
// };